import gql from 'graphql-tag';

export const UPDATE_PLACE_MUTATION = gql`
  mutation UpdatePlace($id: ID!, $input: UpdatePlaceInput!) {
    updatePlace(id: $id, input: $input) {
      place {
        id
      }
    }
  }
`;
